import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'darkadia-forum',
  templateUrl: './forum.component.html',
  styleUrls: ['./forum.component.scss']
})
export class ForumComponent implements OnInit {
  folders: Array<{
    id: number,
    title: string,
    link: string,
    sections: Array<{
      id: string,
      title: string,
      link: string,
      information: string,
      markedTopics: Array<{
        id: number,
        title: string,
        link: string
      }>,
      topics: Array<{
        id: number,
        title: string,
        link: string,
        openedDate: string,
        author: string,
        messagesCount: number,
        lastMessageDate: string,
        lastMessageAuthor: string
      }>
    }>
  }>;

  constructor() { }

  ngOnInit() {
    let topics = [];
    let sections = [];
    topics.push({id:1,title:"Sujet 1",link:"#",openedDate:"01/01/2018",author:"Nivvdiy",messagesCount:0,lastMessageDate:"01/01/2018",lastMessageAuthor:"Nivvdiy"});
    topics.push({ id: 1, title: "Sujet 2", link: "#", openedDate: "01/01/2018", author: "Nivvdiy", messagesCount: 0, lastMessageDate: "01/01/2018", lastMessageAuthor: "Nivvdiy" });
    topics.push({ id: 1, title: "Sujet 3", link: "#", openedDate: "01/01/2018", author: "Nivvdiy", messagesCount: 0, lastMessageDate: "01/01/2018", lastMessageAuthor: "Nivvdiy" });
    sections.push({ id: 1, title: "Section 1", link: "#", information: "Plein d'informations inutiles et dont personnes ne se soucie", topics: topics });
    sections.push({ id: 1, title: "Section 2", link: "#", information: "Pourquoi faire compliquer quand on peut faire simple? En plus j'ai la flemme", topics: topics });
    this.folders = [];
    this.folders.push({ id: 1, title: "Dossier 1", link: "#", sections: sections });
    this.folders.push({ id: 1, title: "Dossier 2", link: "#", sections: sections });
    this.folders.push({ id: 1, title: "Dossier 3", link: "#", sections: sections });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/forum/forum.component.ts